export default __webpack_public_path__ + "static/media/electric-tower.da8cdb08.png";